import { z } from 'zod/v4';

/**
 * Adres przepływu wprowadzania paczki (W1 → W2 → W3). Krok siedzi w `?step=`,
 * bo cała trójka to jeden ekran tej samej paczki, a nie trzy podstrony rekordu.
 */
export enum ChangePackageStep {
  SUMMARY = 'summary',
  SETTLEMENT = 'settlement',
  ACCEPTANCE = 'acceptance',
}

export const changePackageSearchSchema = z.object({
  step: z
    .enum(ChangePackageStep)
    .catch(ChangePackageStep.SUMMARY)
    .optional()
    .default(ChangePackageStep.SUMMARY),
});

export type ChangePackageSearch = z.infer<typeof changePackageSearchSchema>;
